<template>
  <div v-if="message">
    <div
      v-if="!writting"
      class="user-chat"
      :class="{user : isUserLogged}"
    >
      <vue-load-image ref="lazyImage" v-if="user && user.file">
        <img
          slot="image"
          class="user-image"
          :src="user.file.url_view | resizeImage(46, 46)"
          :data-src="user.file.url_view | resizeImage(46, 46)"
        >
        <div
          slot="preloader"
          v-loading="true"
          class="img-loading"
        >
          {{ $t('Loading ....') }}
        </div>
        <div slot="error">
          {{ $t('Network error') }}
        </div>
      </vue-load-image>
      <img
        v-else
        class="user-image"
        src="../../assets/profile-default.png"
      >
      <div class="body-content">
        <div class="header">
          <span
            v-if="user"
            class="user-name"
          >{{ user.name }}</span>
          <span class="user-chat-date">{{ message.created_at | formatDate('Y-M-D h:m') }}</span>
        </div>
        <div class="user-message">
          {{ message.content }}
        </div>
      </div>
      <span
        v-if="isRead"
        class="read"
      ><i class="icon-checked" />Read</span>
    </div>
    <div
      v-if="writting"
      class="user-chat"
      :class="{load : writting}"
    >
      <vue-load-image class="lazyImage" v-if="user && user.file">
        <img
          slot="image"
          class="user-image"
          :src="user.file.url_view | resizeImage(46, 46)"
          :data-src="user.file.url_view | resizeImage(46, 46)"
        >
        <div
          slot="preloader"
          v-loading="true"
          class="img-loading"
        >
          {{ $t('Loading ....') }}
        </div>
        <div slot="error">
          {{ $t('Network error') }}
        </div>
      </vue-load-image>
      <img
        v-else
        class="user-image"
        src="../../assets/profile-default.png"
      >
      <div class="writting">
        <span
          v-if="user"
          class="user-name"
        >{{ user.name }}</span>
        <span>{{ $t('chat-message.writing.text') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { dataGet } from '@fps/vue-toolkit/dist/util';

  export default {
    // eslint-disable-next-line vue/require-prop-types
    props: [ 'isUserLogged', 'isRead', 'writting', 'message' ],
    computed: {
      user() {
        return this.message && this.message.created_by === this.message.user_id ?
          this.message.user : dataGet('ad.user', this.message);
      },
    },
    methods: {
      loadImage () {
        this.$refs.lazyImage.loadWatch()
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AccountSettings/ChatMessage.vue